import React from "react";
import { PortfolioSec } from "./portfolio";

export const Portfolio = () => {
  return (
    <React.Fragment>
      <div className="portfolio-main">
        <PortfolioSec />
      </div>
    </React.Fragment>
  );
};
